import { render } from "./ServicesList.vue?vue&type=template&id=48c4753e&scoped=true&ts=true"
import script from "./ServicesList.vue?vue&type=script&lang=ts"
export * from "./ServicesList.vue?vue&type=script&lang=ts"

import "./ServicesList.vue?vue&type=style&index=0&id=48c4753e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c4753e"]])

export default __exports__